import { render } from "./Mobile.vue?vue&type=template&id=6d6f7c33&scoped=true&ts=true"
import script from "./Mobile.ts?vue&type=script&lang=ts"
export * from "./Mobile.ts?vue&type=script&lang=ts"

import "./Mobile.scss?vue&type=style&index=0&id=6d6f7c33&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6f7c33"]])

export default __exports__